(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("material-filter-form");

    if (!form) return;

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener("change", function () {
        form.submit();
      });
    });
  });
})(jQuery);
